module.exports = __webpack_public_path__ + "img/telarana.92efaa3a.jpeg";